/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Agents_Role_ReadsInputs */



/**
* | output |
* | --- |
* | "Reads" |
*
* @param {Datasets_Agents_Role_ReadsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_agents_role_reads = /** @type {((inputs?: Datasets_Agents_Role_ReadsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Agents_Role_ReadsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Liest")
	return /** @type {LocalizedString} */ ("Reads")
});